import { createContext, useContext, useState } from "react";
import { theme } from "../components/theme";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState("light"); // 👈 по умолчанию светлая

  return (
    <ThemeContext.Provider value={{ mode, setMode, theme: theme[mode] }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);